import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { AlertRoute, AlertPathName } from '@/modules/ta/alert/alert.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${AlertRoute.ALERTS}`,
      name: AlertPathName.ALERTS,
      component: () => import(/* webpackChunkName: "alerts-page" */ './pages/AlertsPage.vue'),
    },
    {
      path: `/${AlertRoute.ALERTS}/new`,
      name: AlertPathName.ALERTS_NEW,
      component: () =>
        import(/* webpackChunkName: "alert-form-page" */ './pages/AlertFormPage.vue'),
      props: true,
    },
    {
      path: `/${AlertRoute.ALERTS}/:id`,
      name: AlertPathName.ALERTFORM,
      component: () =>
        import(/* webpackChunkName: "alert-form-page" */ './pages/AlertFormPage.vue'),
      props: true,
    },
    {
      path: `/${AlertRoute.ALERTS}/tab/:tab?`,
      name: AlertPathName.ALERTS_TAB,
      props: true,
      component: () => import(/* webpackChunkName: "alerts-page" */ './pages/AlertsPage.vue'),
    },
  ],
  Module.ALERT
);
